import {ReportData} from "../../../reports/report.data";
import {collection, field} from "@fedeltapointofsale/data-client";
import {EmployeeReportSelectionData} from "../../../employee/employee/controls/employee-report-selection-control.component";


export class MemberLoyaltySignupReportData extends ReportData<MemberLoyaltySignupReportData> {
    @field reportType: string = "SIMPLE";

    @collection(EmployeeReportSelectionData) employees: EmployeeReportSelectionData[];
}
